import { cn } from '@/shared/lib/utils';
import { fieldTriggerClassName } from './fieldTrigger';
import { Icon } from './Icon';

interface FilterButtonProps {
  /** 필터가 하나라도 적용돼 있으면 '필터 적용됨' 강조 상태 */
  active: boolean;
  onClick: () => void;
  className?: string;
}

/**
 * Figma Input "필터" — Select 트리거 모양으로 필터 드로어를 연다.
 * 적용 중이면 primary-50 배경 · primary-500 테두리 · accent 글자의 '필터 적용됨'.
 */
export function FilterButton({
  active,
  onClick,
  className,
}: FilterButtonProps) {
  return (
    <button
      type="button"
      aria-haspopup="dialog"
      className={cn(
        fieldTriggerClassName,
        'min-w-20',
        active && 'gap-2 border-primary-500 bg-primary-50',
        className,
      )}
      onClick={onClick}
    >
      <span
        className={cn(
          'text-body-14 font-medium whitespace-nowrap',
          active ? 'text-fg-accent' : 'text-fg-primary',
        )}
      >
        {active ? '필터 적용됨' : '필터'}
      </span>
      <Icon name={active ? 'filterActive' : 'filter'} size={24} />
    </button>
  );
}
